import { createSelector } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../constants/fetchStatuses';
import { ReducerState } from '../../store.types';

export const indexFundSelector = ({ indexFund }: ReducerState) => indexFund;
export const indexFundLoadingSelector = createSelector(
  indexFundSelector,
  ({ fetchStatus }) => fetchStatus === fetchStatuses.pending,
);
